/**
 * Admin Presets — `/admin/presets`
 *
 * Registry-wide staged review: left queue includes presets with zero outputs; right pane exposes
 * admin-only prompts and prompt → start image → optional end image → video QA.
 *
 * @feature-spec brain/vidmax/feature-specs/admin-presets.md
 */
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { ReviewWall } from "~/components/PresetReview/ReviewWall"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function PresetReviewPage() {
  return (
    <>
      <CustomHead title="Preset Review" />
      <ReviewWall />
    </>
  )
}

function PresetReviewWrapper() {
  return (
    <SuperAdminLayout fixedViewport>
      <PresetReviewPage />
    </SuperAdminLayout>
  )
}

const presetReviewSearchSchema = z.object({
  id: z.string().optional(),
  q: z.string().optional(),
  presetGroup: z.enum(["none", "model", "category", "media"]).optional(),
  queue: z
    .enum(["all", "prompt", "start_image", "end_image", "video", "complete", "no_outputs", "no_video", "failed"])
    .optional(),
  media: z.string().optional(),
  model: z.string().optional(),
  category: z.string().optional(),
  status: z.string().optional(),
  subject: z.string().optional(),
  sessionId: z.string().optional(),
  batchId: z.string().optional(),
})

export const Route = createFileRoute("/admin/presets")({
  validateSearch: presetReviewSearchSchema,
  component: PresetReviewWrapper,
})
